<template>
  <div class="group-add maxW">
    <div class="crumbs-link">
      <span @click="back">我的圈组</span>
      <strong>
        <i>></i>新建圈组</strong>
    </div>
    <div class="group-add-cont">
      <el-form class="group-add-form" ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="封面图片" prop="imageUrl2">
          <imgUpload v-on:picture="getImgPath"></imgUpload>
        </el-form-item>
        <el-form-item label="圈组名称" prop="name">
          <el-input v-model.trim="form.name" placeholder="最多可以输入20个字符" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="学段" prop="study_section_id" class="g-item-inline">
          <el-select v-model="form.study_section_id" @change="getOrgLevel2" placeholder="请选择学段">
            <el-option v-for="(item, index) in orgLevel2" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级" prop="grade_id" class="g-item-inline">
          <el-select v-model="form.grade_id" @change="getSubject" placeholder="请选择年级">
            <el-option v-for="(item, index) in orgLevel3" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目" prop="subject_id" class="g-item-inline">
          <el-select v-model="form.subject_id" placeholder="请选择科目">
            <el-option v-for="(item, index) in orgSubject" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邀请成员" prop="join_user">
          <el-button type="primary" @click="openMemberDialog">选择</el-button>
        </el-form-item>
        <el-form-item>
          <el-tag v-for="tag in membersNamesData" :key="tag.name" :type="tag.type" closable @close="cancelMemberChecked(tag)">
            {{tag.name}}
          </el-tag>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="选择成员" :visible.sync="dialogTableVisible" width="800px">
      <el-row>
        <el-col :span="8">
          学段
          <el-select v-model="groupTableData.study_id" @change="getOrgLevel2T" placeholder="请选择学段" size="small">
            <el-option v-for="(item, index) in orgLevel2T" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          年级
          <el-select v-model="groupTableData.org_id" placeholder="请选择年级" size="small">
            <el-option v-for="(item, index) in orgLevel3T" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-input placeholder="搜索教师名字" class="input-with-select" size="small" v-model.trim="groupTableData.name" @keyup.enter.native="getMembersData">
            <el-button slot="append" icon="el-icon-search" @click="getMembersData"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <template>
        <el-table ref="multipleTable" :data="membersData" row-key="id" border tooltip-effect="dark" style="width: 100%" @selection-change="membersChacked">
          <el-table-column type="selection" width="35" align="center" :reserve-selection="true">
          </el-table-column>
          <el-table-column prop="number" label="登陆账号" width="140" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="用户名" width="190" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="sub_name" label="科目" width="190" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="组织架构" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.org_name==null?'暂无绑定组织':scope.row.org_name }}</template>
          </el-table-column>
        </el-table>
        <el-pagination background v-if="total_number > groupTableData.size" class="pageing" @size-change="handleSizeChange" @current-change="currentChange" :current-page="groupTableData.page" :page-size="groupTableData.size" layout="total, prev, pager, next, jumper" :total="total_number">
        </el-pagination>
        <div class="group-add-tableBtns">
          <el-button size="small" @click="resetTable()">重置</el-button>
          <el-button size="small" type="primary" @click="sureSelect()">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import imgUpload from "./imgUpload";
export default {
  name: "",
  data() {
    return {
      form: {
        picture: "",
        name: "",
        study_section_id: "",
        grade_id: "",
        subject_id: "",
        join_user: "",
        create_id: this.$store.getters.userInfo.id
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入圈组名称",
            trigger: "blur"
          }
        ],
        study_section_id: [
          { required: true, message: "请选择学段", trigger: "change" }
        ],
        grade_id: [
          { required: true, message: "请选择年级", trigger: "change" }
        ],
        subject_id: [
          { required: true, message: "请选择科目", trigger: "change" }
        ],
        join_user: [
          { required: true, message: "请邀请成员", trigger: "change" }
        ]
      },
      orgLevel2: [],
      orgLevel3: [],
      orgSubject: [],
      //弹窗部分：
      dialogTableVisible: false,
      orgLevel2T: [],
      orgLevel3T: [],
      groupTableData: {
        study_id: "",
        org_id: "",
        name: "",
        status: 1,
        data_type: 2,
        role_id: 6,
        page: 1,
        size: 7,
        is_diffplat: 1
      },
      membersNamesData: [],
      membersData: [],
      memberSelected: [],
      total_number: 0
    };
  },
  created() {
    this.getOrgLevel2();
    this.getOrgLevel2T();//选择成员：弹窗里面的
  },
  watch: {
    
  },
  methods: {
    getImgPath(picture) {
      this.form.picture = picture;
    },
    getOrgLevel2() {
      let success = res => {
        let data = res.data;
        this.orgLevel2 = data;
        if (this.orgLevel2[0].id) {
          this.orgLevel2[0].study_id = this.orgLevel2[0].id;
        }
        this.getOrgLevel3();
      };
      this.$ajax({
        url: "api/org/org",
        method: "get",
        params: {
          level: 2,
          status: 1,
          direction: "balance",
          data_type: "arr_all"
        },
        func: {
          success: success
        }
      });
    },
    getOrgLevel3() {
      let success = res => {
        let data = res.data;
        if (data.length === 0) {
          return;
        }
        this.orgLevel3 = data;
        if (this.orgLevel3[0].id) {
          this.form.grade_id = this.orgLevel3[0].id;
        }
        this.getSubject();
      };
      this.$ajax({
        url: "api/org/org",
        method: "get",
        params: {
          level: 3,
          status: 1,
          direction: "balance",
          data_type: "arr_all",
          pid: this.form.study_section_id
        },
        func: {
          success: success
        }
      });
    },
    getSubject() {
      let success = res => {
        let data = res.data;
        this.orgSubject = data;
        if (this.orgSubject[0].id) {
          this.form.subject_id = this.orgSubject[0].id;
        }
      };
      this.$ajax({
        url: "api/cate/subject",
        method: "get",
        params: {
          type: 2,
          org_id: this.form.grade_id,
          status: 1
        },
        func: {
          success: success
        }
      });
    },
    openMemberDialog() {
      this.dialogTableVisible = true;
      this.getMembersData();
    },
    resetTable(rows) {
      this.groupTableData = {
        study_id: "",
        org_id: "",
        name: "",
        status: 1,
        data_type: 2,
        role_id: 6,
        page: 1,
        size: 7,
        is_diffplat: 1
      };
      this.getMembersData();
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getMembersData() {
      let success = res => {
        this.membersData = res.data.data;
        this.total_number = res.data.data_sum;
      };
      this.$ajax({
        url: "/api/user/user",
        method: "get",
        params: this.groupTableData,
        func: {
          success: success
        }
      });
    },
    getOrgLevel2T() {
      let success = res => {
        let data = res.data;
        this.orgLevel2T = data;
        if (this.orgLevel2T[0].id) {
          this.orgLevel2T[0].study_id = this.orgLevel2T[0].id;
        }
        this.getOrgLevel3T();
      };
      this.$ajax({
        url: "api/org/org",
        method: "get",
        params: {
          level: 2,
          status: 1,
          direction: "balance",
          data_type: "arr_all"
        },
        func: {
          success: success
        }
      });
    },
    getOrgLevel3T() {
      let success = res => {
        let data = res.data;
        if (data.length === 0) {
          return;
        }
        this.orgLevel3T = data;
        if (this.orgLevel3T[0].id) {
          this.groupTableData.org_id = this.orgLevel3T[0].id;
        }
      };
      this.$ajax({
        url: "api/org/org",
        method: "get",
        params: {
          level: 3,
          status: 1,
          direction: "balance",
          data_type: "arr_all",
          pid: this.groupTableData.study_id,
        },
        func: {
          success: success
        }
      });
    },
    // 选中成员弹窗里table，checkbox勾选到的数据:
    membersChacked(val) {
      this.memberSelected = val;
      // console.log(val)
    },
    //确定选中成员：
    sureSelect() {
      if (this.memberSelected.length == 0) {
        this.$message.warning("请选择成员");
        return false;
      }
      //确定选中的成员数据，顺便去重处理：
      let n_arr = this.membersNamesData;
      let s_arr = this.memberSelected;
      n_arr.push.apply(n_arr, s_arr);
      this.membersNamesData = this.FilterByName(n_arr, 'id');
      //邀请的成员Id,字符串格式传去后台：
      this.form.join_user = this.arrChangeString(this.membersNamesData);
      this.dialogTableVisible = false;
    },
    cancelMemberChecked(tag) {
      // console.log(tag)
      //把弹窗里table的选中数据对应的选项也删掉
      for (let i = 0; i < this.memberSelected.length; i++) {
        if (this.memberSelected[i].id == tag.id) {
          this.memberSelected.splice(i, 1);
        }
      }

      for (let i = 0; i < this.$refs.multipleTable.selection.length; i++) {
        if (this.$refs.multipleTable.selection[i].id == tag.id) {
          this.$refs.multipleTable.selection.splice(i, 1);
        }
      }
      //表单里面成员数据删除对应的/
      this.membersNamesData.splice(this.membersNamesData.indexOf(tag), 1);
      //字符串也删对应
      this.form.join_user = this.arrChangeString(this.membersNamesData);
    },

    //json数组data，根据Name字段去重
    FilterByName(data, Name) {
      var map = {},
        dest = [];
      for (var i = 0; i < data.length; i++) {
        var ai = data[i];
        if (i == 0) {
          dest.push(ai);
        } else {
          var filterData = dest.filter(function (e) {
            return e[Name] == ai[Name];
          })
          if (filterData.length == 0) {
            dest.push(ai);
          }
        }
      }
      return dest;
    },
    // 拼字符串
    arrChangeString(arr) {
      let userString = "";
      for (var value of arr) {
        userString += value.id + ",";
      }
      return userString.substring(0, userString.length - 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.uploadOrNot && this.selectFileOrNot) {
            this.$message.warning("请等待封面图片上传完成");
          } else {
            this.saveLive();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveLive() {
      let data = this.form;
      let success = data => {
        this.$message.success(data.msg);
        setTimeout(() => {
          this.$router.push({ path: "/group/manage/selfCreated" });
        }, 1000);
      };
      let fail = data => {
        let msg = "";
        if (typeof data.msg == "object") {
          for (var i = 0; i <= data.msg.length - 1; i++) {
            msg +=data.msg[i];
          }
        } else {
          msg = data.msg;
        }
        this.$message.warning(msg);
      };
      this.$ajax.post("/api/group/group_list", data, {
        func: { success: success, fail: fail }
      });
    },
    back() {
      this.$router.back();
    },
    handleSizeChange(val) {
      this.groupTableData.page = 1;
      this.groupTableData.size = val;
      this.getMembersData();
    },
    currentChange(val) {
      // this.membersData = [];
      this.groupTableData.page = val;
      this.getMembersData();
    }
  },
  components: {
    imgUpload
  }
};
</script>

